import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import servicesService from '../../api/servicesService'

const initialState = {
  services: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
}

// Fetch service details
export const fetchServices = createAsyncThunk(
  'services/fetchAll',
  async (applicationAPMID, thunkAPI) => {
    try {
      return await servicesService.getServices(applicationAPMID)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
    },
    clearServices: (state) => {
      state.services = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.services = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, clearServices } = servicesSlice.actions
export default servicesSlice.reducer
